import type {Content} from '@prismicio/client'
import type {SliceComponentProps} from '@prismicio/react'
import type {Context} from 'src/common/types'
import {StaticHeaderDefault} from './Default'
import {StaticHeaderV2} from './V2Variation'

/**
 * Props for `StaticHeader`.
 */
export type StaticHeaderProps = SliceComponentProps<Content.StaticHeaderSlice> & {context: Context}

/**
 * Component for "StaticHeader" Slices.
 */
const StaticHeader = ({slice, context: {pageUid, buttonsData}}: StaticHeaderProps) => {
  switch (slice.variation) {
    case 'v2':
      return <StaticHeaderV2 slice={slice} pageUid={pageUid} buttonsData={buttonsData} />
    case 'default':
      return <StaticHeaderDefault slice={slice} pageUid={pageUid} buttonsData={buttonsData} />
    default:
      return null
  }
}

export default StaticHeader
